const worqRoutes = {
    home: '/',
    products: '/capabilities',
    solutions: '/features',
    caseStudies: '/casestudies',
    about: '/about',
    privacyPolicy: '/privacy-policy',
};

export default worqRoutes;
